import { Modal } from "@mantine/core";
import { noop } from "lodash";
import { ProviderUserRole } from "@/__generated__/graphql";
import styles from "./claimableModal.module.scss";

type User = {
  providerUserId: string;
  providerId: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  jobTitle?: string | null;
  role: ProviderUserRole;
  active: boolean;
  createdTimestamp: string;
};

type ClaimableModalProps = {
  user: User | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (user: User) => void;
  isLoading?: boolean;
};

export const ClaimableModal = ({
  user,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: ClaimableModalProps) => {
  if (!user) return null;

  const isDeactivating = user.active;

  const handleConfirm = () => {
    onConfirm(user);
  };

  return (
    <Modal
      opened={isOpen}
      onClose={isLoading ? noop : onClose}
      closeOnClickOutside={!isLoading}
      closeOnEscape={!isLoading}
      withCloseButton={false}
      classNames={{
        content: styles.modalContent,
        body: styles.modalBody,
      }}
      centered
      size={531}
    >
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <p className={styles.modalText}>
            <span className={styles.modalTitle}>
              {isDeactivating
                ? "Are you sure you want to deactivate this user?"
                : "Are you sure you want to reactivate this user?"}
            </span>
            <br />
            {isDeactivating
              ? "Deactivated users will still be visible in your account but no longer have access to Claimable."
              : "This user will regain access to Claimable."}
          </p>
        </div>
        <div className={styles.modalActions}>
          <button
            className={styles.cancelButton}
            onClick={onClose}
            disabled={isLoading}
            type="button"
          >
            Cancel
          </button>
          <button
            className={`${styles.confirmButton} ${isDeactivating ? styles.dangerButton : styles.primaryButton}`}
            onClick={handleConfirm}
            disabled={isLoading}
            type="button"
          >
            {isDeactivating ? "Deactivate user" : "Reactivate user"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ClaimableModal;
